import styled, { css } from 'styled-components'

import { textStyles } from '../../../theme'

export const Label = styled.label<{ $error?: boolean }>`
  display: inline-block;
  ${textStyles.tiny};
  color: grey;

  &[required]:after {
    content: ' *';
  }

  ${(props) =>
    props.$error &&
    css`
      color: #ff0000;
    `}
`
